import React, {useContext, useMemo} from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {AutoSizer, List} from "react-virtualized";

import {setUiPopupState} from "../../../actions/A_Popups";
import UIPopupContext from "../../PageLayout/Popups/UIPopupContext";
import CheckBox from "../../PageLayout/CheckBox";


const JobAssociateFabricatorPopupContentList = (props) => {

  const {} = props;

  const {uiPopupContext, uiPopupDispatch} = useContext(UIPopupContext);

  const checkboxClick = (referralItem) => {
    const alreadySelected = uiPopupContext.childFabricatorId
      && (uiPopupContext.childFabricatorId === referralItem.childFabricatorId);
    uiPopupDispatch({
      parentFabricatorName: alreadySelected ? "" : referralItem.parentFabricatorName,
      childFabricatorId: alreadySelected ? "" : referralItem.childFabricatorId,
      childFabricatorName: alreadySelected ? "" : referralItem.childFabricatorName,
      percentage: alreadySelected ? "" : referralItem.percentage,
      qcPercentage: alreadySelected ? "" : referralItem.qcPercentage,
    })
  }

  const referralList = useMemo(() => {
    if (uiPopupContext.searchText) {
      const searchText = uiPopupContext.searchText.toLowerCase().trim();
      return uiPopupContext.referralList.filter(refItem => {
        return (refItem.childFabricatorName || "").toLowerCase().includes(searchText);
      })
    }
    return uiPopupContext.referralList
  }, [uiPopupContext.referralList, uiPopupContext.searchText])

  return (
    <div className="absolute h-full ui-list w-full font--16 text-left color-blue">
      <AutoSizer>
        {({width, height}) => {
          return (
            <List
              height={height}
              className="scrollbar3 pr-1"
              width={width}
              rowCount={referralList.length}
              rowHeight={44}
              rowRenderer={({index, key, style}) => {
                const referralItem = referralList[index];
                if (!referralItem) {
                  return null
                }
                return (
                  <div style={style} key={key} className={"ui-list-li border-box flex flex--center flex--between"}>
                    <div className="pr-1 flex flex--center flex--between w-full">
                      <CheckBox checked={uiPopupContext.childFabricatorId === referralItem.childFabricatorId}
                                innerStyle="none"
                                type={"tiny"}
                                className="pr-two-lines"
                                text={referralItem.childFabricatorName}
                                onChecked={() => checkboxClick(referralItem)}/>
                      <span className="secondary">{referralItem.percentage}%</span>
                    </div>
                  </div>
                )
              }}
            />
          )
        }}
      </AutoSizer>
    </div>
  )
};

const mapStateToProps = () => {
  // const {auth, asCustomer} = state;
  return {
    // auth,
    // asCustomer,
  };
};

const mapDispatchToProps = {
  setUiPopupState,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(JobAssociateFabricatorPopupContentList)
)
